var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (suggestion) {
if ( suggestion.isWithImages())
{
buf.push("<div class=\"typeahead-suggestion-thumbnail\"><span><img" + (jade.attr("src", suggestion.cropUrlFor({ width: 32, height: 32 }), true, true)) + " width=\"32\" height=\"32\" onerror=\"this.style.display=&quot;none&quot;;\"></span></div>");
}
buf.push("<div class=\"typeahead-suggestion-name\">" + (jade.escape(null == (jade_interp = suggestion.get('name')) ? "" : jade_interp)) + "</div><div class=\"typeahead-suggestion-affordance\"><div class=\"avant-garde-button-black is-tiny\">Add</div></div>");}.call(this,"suggestion" in locals_for_with?locals_for_with.suggestion:typeof suggestion!=="undefined"?suggestion:undefined));;return buf.join("");
};
module.exports = template;